<template>
  <div :class="['rereadUpImg', { phoHeight: !isEmpty }]">
    <div class="uploadImgBox">
      <van-image
        class="listImg"
        v-for="(item, index) in fileList"
        :key="index"
        :src="item"
        fit="cover"
        @click="previewImage(index)"
      >
      </van-image>
      <template v-if="$root.isApp">
        <div class="cameraBox">
          <div class="fixedbottom" v-if="isEmpty">
            <div class="tmallBtn" @click="arouse">拍照</div>
          </div>
          <div class="editFixedbottom" v-if="!isEmpty">
            <div class="editBtn" @click="arouse">编辑</div>
            <div class="tmallBtn" @click="goSubmit">提交</div>
          </div>
        </div>
      </template>
      <template v-else>
        <van-uploader
          :deletable="false"
          :max-count="1"
          :after-read="afterRead"
          :accept="imageMimeTypes"
          :preview-image="false"
        >
          <div class="fixedbottom" v-if="isEmpty">
            <div class="tmallBtn">拍照</div>
          </div>
          <div class="editFixedbottom" v-if="!isEmpty">
            <div class="editBtn">编辑</div>
            <div class="tmallBtn" @click="goSubmit">提交</div>
          </div>
        </van-uploader>
      </template>
    </div>

    <van-image-preview v-model="isShowPreview" :images="fileList" get-container="body" />

    <van-image-preview
      v-model="isShowExamplePreview"
      :images="defaultExampleList"
      get-container="body"
    />
  </div>
</template>

<script>
import Compressor from 'compressorjs';
import { ADMIN_URL } from '@/utils/common';
import axios from 'axios';

export default {
  components: {},
  props: {},
  data() {
    return {
      isEmpty: true,
      imageMimeTypes: 'image/*',
      isShowPreview: false, // 是否开启预览
      isShowExamplePreview: false,
      defaultExampleList: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E7%BC%96%E7%BB%84%2018%402x.png`,
      ],
      loading: false,
      fileList: [],
    };
  },
  methods: {
    arouse() {
      if (this.$root.$data.isApp) {
        window.uploaderFiles = (value) => {
          const data = JSON.parse(value);
          console.log(value)
          console.log(data)
          if (data.success !== 1) {
            this.$toast.fail('上传失败');
          } else {
            this.isEmpty = false;
            this.fileList = [];
            let tempImg = data.images[0]+'?x-oss-process=image/quality,q_60'
            this.fileList.push(tempImg);
            console.log(tempImg)
            console.log(this.fileList)
            this.$emit('getListFile', this.fileList);
          }
        };
        this.$sendToApp('arouseImagePicker', { pickNum: 1 });
      }
    },
    previewImage(index) {
      // 图片预览
      this.isShowPreview = true;
    },

    afterRead(file) {
      let that= this;
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true,
      });
      const path = `${ADMIN_URL}/ref/v1/oss/file?type=image`;
      const formData = new FormData();
      let quality = 1
      if (file.file.size < 1000 * 1000) { //小于1M
        quality = 0.8
      } else if (file.file.size < 5000 * 1000) { //小于5M
        quality = 0.5
      } else if (file.file.size < 10000 * 1000) { //小于10M
        quality = 0.3
      } else { //大于10M
        quality = 0.1
      }
      new Compressor(file.file, {
        quality: quality,
        success(result) {
          let newFile = new File([result], result.name, { type: result.type })
          formData.append('file', newFile);
          axios({
          url: path,
          method: 'POST',
          data: formData,
          processData: false, // 告诉axios不要去处理发送的数据(重要参数)
          contentType: false, // 告诉axios不要去设置Content-Type请求头
        })
          .then((res) => {
            if (res.data.code === 0) {
              that.fileList = [];
              that.fileList.push(res.data.data);
              that.$emit('getListFile', that.fileList);
              that.isEmpty = false;
            } else {
              that.$toast.fail('上传失败');
            }
            that.$toast.clear();
          })
        },
      });
    },

    goSubmit() {
      this.$emit('cardSubmit');
    },
  },
};
</script>

<style scoped lang="scss">
.rereadUpImg {
  .uploadImgBox {
    height: 100%;
    overflow: auto;
    .cameraBox {
      position: relative;
      width: 678px;
      height: 80px;
    }
    .listImg {
      display: block !important;
      ::v-deep .van-image__img {
        display: block;
        max-width: 100%;
        height: 100%;
        overflow: auto;
        margin: 0 auto;
        border-radius: 18px;
      }
    }
    ::v-deep .van-uploader__input {
      position: fixed;
      top: auto;
      bottom: 32px;
      height: 45px;
      opacity: 0;
    }
    ::v-deep .closeIcon {
      display: none;
    }
  }
  .fixedbottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 167px;
    background: #ffffff;
    border-radius: 22px 22px 2px 2px;
    padding-top: 22px;
    box-shadow: 0px -4px 14px 0px rgba(0, 0, 0, 0.05);
    .tmallBtn {
      width: 678px;
      height: 80px;
      line-height: 80px;
      background: #ff7f41;
      border-radius: 49px;
      margin: 0 auto;
      color: #fff;
      font-size: 32px;
      text-align: center;
    }
  }
  .editFixedbottom {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 167px;
    background: #ffffff;
    border-radius: 22px 22px 2px 2px;
    padding-top: 22px;
    display: flex;
    box-shadow: 0px -4px 14px 0px rgba(0, 0, 0, 0.05);
    .editBtn {
      width: 330px;
      height: 80px;
      border-radius: 45px;
      border: 2px solid #ff7f41;
      line-height: 80px;
      margin: 0 auto;
      color: #ff7f41;
      font-size: 32px;
      text-align: center;
    }

    .tmallBtn {
      width: 330px;
      height: 80px;
      background: #ff7f41;
      border-radius: 45px;
      line-height: 80px;
      margin: 0 auto;
      color: #fff;
      font-size: 32px;
      text-align: center;
    }
  }
}
.phoHeight {
  height: calc(100vh - 167px - 100px);
  ::v-deep .van-uploader__input {
    width: 50%;
  }
}
</style>
